import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import Typography from 'src/common/components/Typography';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import stickers from 'src/common/components/Sticker/stickerMap';
import Image from 'next/image';
import { relativeLoader } from 'src/common/utils/imageHelpers';
import { NEXT_STATIC_IMAGES } from 'src/common/constants';
import AppLinks from 'src/common/components/AppLinks';
import styles from './MobileAppsCTA.module.scss';

const getSticker = (stickerName: 'yacht' | 'backflip') => {
  const src = `${NEXT_STATIC_IMAGES}stickers/${stickerName}.png`;
  const sticker = stickers.find(({ name }) => name === stickerName);
  const aspectRatio = sticker?.width && sticker.height ? sticker.width / sticker.height : 1;

  return {
    src,
    sticker,
    aspectRatio,
  };
};

const MobileAppsCTA: FC = () => {
  const [t] = useTranslation('mobile-apps-page');
  const [yacht, backflip] = [getSticker('yacht'), getSticker('backflip')];
  return (
    <div className={styles.layout}>
      <PitchPageLayout
        backgroundColor="ivory"
      >
        <div className={styles.root}>
          <div className={styles.main}>
            <div className={styles.text}>
              <Typography
                type="h2"
                size="display-5"
                sizeFromBreakpointM="display-4"
              >
                {t('cta-title')}
              </Typography>
              <Typography
                type="p"
                size="body-xl"
              >
                {t('cta-subtitle')}
              </Typography>
            </div>
            <div className={styles.appLinks}>
              <AppLinks
                outline="white"
                classNameModifier="pitchPageMobileApps"
              />
            </div>
          </div>
          <div className={styles.stickers}>
            <div className={styles.yacht}>
              <Image
                src={yacht.src}
                width={80 * yacht.aspectRatio}
                height={80}
                alt="yacht"
                loader={relativeLoader}
              />
            </div>
            <div className={styles.backflip}>
              <Image
                src={backflip.src}
                width={116 * backflip.aspectRatio}
                height={116}
                alt="backflip"
                loader={relativeLoader}
              />
            </div>
          </div>
        </div>
      </PitchPageLayout>
    </div>
  );
};

export default MobileAppsCTA;
